import { Col, Spin, } from 'antd';

function LoaderComponent({ tip }) {
    return (
        <Col xs={24} xl={24} sm={24} md={24} className="loader-container">
            <Spin size="large" tip={tip ? tip : "Loading..."} color={'black'} />
        </Col>
    );
}

export default LoaderComponent;